import { parseH3liveHandoffResponse, parseH3liveRoomsResponse } from '@drama/contracts'

/**
 * h3live 域：为嵌入的换装跳舞直播间换身份交接令牌。
 * @param {ReturnType<import('../transport.js').createTransport>} transport
 */
export function createH3liveApi(transport) {
  return {
    /**
     * 公开：首页区块、导航入口和 /live 页面共用；embed_origin 为空串表示本环境没接 h3live。
     * @returns {Promise<import('@drama/contracts/platform').H3liveRoomsResponseT>}
     */
    rooms() {
      return transport.request('GET', '/api/sk/h3live/rooms', { public: true, parse: parseH3liveRoomsResponse })
    },

    /**
     * 需要登录态；匿名请求服务端回 401，调用方只在已登录时调它。
     * @returns {Promise<import('@drama/contracts/platform').H3liveHandoffResponseT>}
     */
    handoff() {
      return transport.request('POST', '/api/sk/h3live/handoff', { parse: parseH3liveHandoffResponse })
    },
  }
}
